import axios from 'axios'

// Pulls the human-readable reason out of a failed API call. NestJS puts the real message in
// response.data.message (a string, or an array of validation strings); axios's own err.message is
// just "Request failed with status code 400", so we always prefer the backend's message when present.
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const message = (error.response?.data as { message?: string | string[] } | undefined)?.message
    if (Array.isArray(message)) return message.join(', ')
    if (typeof message === 'string' && message) return message
  }
  if (error instanceof Error && error.message) return error.message
  return fallback
}
